/**
 * @file Data zoom model
 */


    var DataZoomModel = require('./DataZoomModel');

    module.exports = DataZoomModel.extend({

        type: 'dataZoom.select'

    });




//////////////////
// WEBPACK FOOTER
// ./node_modules/echarts/lib/component/dataZoom/SelectZoomModel.js
// module id = 1117
// module chunks = 0